export default "__VITE_ASSET__DwbY9v3t__"